import { Injectable } from '@angular/core';
import { BaseHttpService } from '@core/data/http/base-http.service';
import { Observable } from 'rxjs';
import { SearchRequest } from './search-request';
import { SearchScopeType } from './search-scope-type';

@Injectable({ providedIn: 'root' })
export class SearchDataService extends BaseHttpService {
    private urls = {
        search: '/search',
        boards: '/search/boards',
        connections: '/search/connections',
        connectionFilters: '/search/connections/filters',
        ihdSites: '/search/ihdconfig'
    };

    

    /**
     * Base search request.
     * @param request
     * @returns {Observable<Response>}
     */
    search(request: SearchRequest): Observable<any> {
        const requestURL: string = this.urls.search + this.toQueryParams(request);
        return this.get(requestURL);
    }

    /**
     * Search companies.
     * @param keywords
     * @param page
     * @returns {Observable<any>}
     */
    searchCompanies(keywords: string, page?: number): Observable<any> {
        const searchRequest = new SearchRequest(
            SearchScopeType.COMPANIES,
            keywords
        );

        if (page) {
            searchRequest.page = page;
        }

        return this.search(searchRequest);
    }

    searchIHDSites(query: string) {
        const requestURL: string = this.urls.ihdSites + this.toQueryParams({ q: query });
        return this.get(requestURL);
    }
}
